module.exports = {"cognito":{"poolId":"eu-west-2:9f25baaf-32d1-41fc-a9aa-8c45bb8fd35e"},"lex":{"botName":"Mykadamy_a","initialText":"You can ask me for help ordering flowers. Just type \"order flowers\" or click on the mic and say it.","initialSpeechInstruction":"Say 'Hi' to get started."},"polly":{"voiceId":"Salli"},"ui":{"parentOrigin":"http://localhost:8080","pageTitle":"Order Flowers Bot","toolbarTitle":"Order Flowers"},"recorder":{"preset":"speech_recognition"}}


//////////////////
// WEBPACK FOOTER
// ./src/config/config.test.json
// module id = d6Aa
// module chunks = 1